export default __webpack_public_path__ + "static/media/kit-background.c3333f42.png";